import { apiClient } from '../../../services/api';

export interface OrganizationResponse {
    organizationId: string;
    name: string;
    taxId: string;
    invitationCode: string;
    logoUrl?: string;
    planName: string;
    maxUsers: number;
    maxStorage: number;
    maxSignatures: number;
    currentUsersCount: number;
}

export interface OrganizationUserResponse {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    nationalId?: string;
    phoneNumber?: string;
    role: string;
    status: string;
    createdAt?: string;
    lastLogin: string;
}

export interface OrganizationInvitationResponse {
    invitationId: string;
    code: string;
    expiresAt: string;
    isUsed: boolean;
    createdBy: string;
    createdAt: string;
}

export interface UpdateOrganizationUserData {
    firstName?: string;
    lastName?: string;
    email?: string;
    nationalId?: string;
    phoneNumber?: string;
}

export const organizationApi = {
    getOrganization: async (): Promise<OrganizationResponse> => {
        const response = await apiClient.get('/organization/me');
        return response.data;
    },

    getUsers: async (): Promise<OrganizationUserResponse[]> => {
        const response = await apiClient.get('/organization/users');
        return response.data;
    },

    createInvitation: async (): Promise<OrganizationInvitationResponse> => {
        const response = await apiClient.post('/organization/invitations');
        return response.data;
    },

    updateUser: async (userId: string, data: UpdateOrganizationUserData): Promise<OrganizationUserResponse> => {
        const response = await apiClient.put(`/organization/users/${userId}`, data);
        return response.data;
    },

    updateUserStatus: async (userId: string, status: string): Promise<OrganizationUserResponse> => {
        const response = await apiClient.put(`/organization/users/${userId}/status`, { status });
        return response.data;
    },

    deleteUser: async (userId: string): Promise<void> => {
        await apiClient.delete(`/organization/users/${userId}`);
    },

    uploadLogo: async (file: File): Promise<OrganizationResponse> => {
        const formData = new FormData();
        formData.append('logo', file);
        const response = await apiClient.post('/organization/branding/logo', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }
};
